import { Button, Checkbox, Col, DatePicker, Input, Popconfirm, Row, Select, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
import SelectAccounts from "./selectAccounts.js";
import SelectRemoteServer from "./selectRemoteServer.js";
const { TextArea } = Input;

function ActiveAccounts(props) {
  const [profileModel, setProfileModel] = useState(testProfile);
  const [time, setTime] = useState(new Date());
  const [accounts, setAccounts] = useState('');
  const [count, setCount] = useState(0);
  const [runAll, setRunAll] = useState(false);
  const [runLimit, setRunLimit] = useState(10);
  const [clearSchedules, setClearSchedules] = useState(false);
  const [verifyAd, setVerifyAd] = useState(true);
  const [needActive, setNeedActive] = useState(false);
  const [ignoreDie, setIgnoreDie] = useState(false);
  const [cancelAfterVerify, setCancelAfterVerify] = useState(true);
  const [firstFileError, setFirstFileError] = useState(false);
  const [whopay, setWhopay] = useState(true);
  const [selectNoPayer, setSelectNoPayer] = useState(false);
  const [fillDuns, setFillDuns] = useState(false);
  const [selectOrg, setSelectOrg] = useState(false);
  const [verifyDUNS, setVerifyDUNS] = useState(true);
  const [mccId, setMccId] = useState('');
  const [mccList, setMccList] = useState([]);
  const [name, setName] = useState('MAI DUC TRANH');
  const [orgName, setOrgName] = useState('CAPIVARA LLC');
  const [address, setAddress] = useState('117 S Lexington St Ste 100');
  const [duns, setDuns] = useState('132172939');
  const [zip, setZip] = useState('64701-2444');
  const [city, setCity] = useState('Harrisonville');
  const [state, setState] = useState('Colorado');
  const [fileType, setFiletype] = useState('Passport');

  const [files, setFiles] = useState('1.pdf,2.pdf/3.pdf/7.pdf');
  const [file, setFile] = useState('ADE LLC.pdf');

  const [runRemote, setRunRemote] = useState(false);
  const [server, setServer] = useState('');
  const [messageApi, contextHolder] = message.useMessage();

  const active = async () => {
    let body = {
      jobName: `active-accounts-${profileModel?.data?.name}`,
      time: time,
      data: {
        profileId: props.profile.id,
        accounts: accounts,
        runAll: runAll,
        runLimit: runAll? 1000 : runLimit,
        needClearSchedules: clearSchedules,
        verifyAd,
        needActive,
        ignoreDie,
        cancelAfterVerify,
        firstFileError,
        mccId: mccList?.length > 0 ? mccList[0] : mccId,
        mccList: mccList.length > 0 ? mccList : [mccId],
        verifyInfo: {
          name: name,
          orgName: orgName,
          address: address, 
          duns: duns,
          city: city,
          state: state,
          zip: zip,
          file: file,
          type: fileType
        },
        files,
        verifyDUNS,
        whopay,
        selectNoPayer,
        fillDuns,
        selectOrg,
        runRemote,
        userName: `${localStorage.getItem('ga-userName')+server}`
      },
    };
    axios
      .post(`${API_HOST}/api/schedule/active`, body)
      .then((res) => messageApi.success("Đã đặt lệnh"))
      .catch((e) => {
        console.log("🚀 ~ active ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const onOpenChange = (open) => {
    if (open) {
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };
  useEffect( () => {
    const verifyDuns = localStorage.getItem('verify-duns-api');
    if(verifyDuns) {
      setVerifyDUNS(verifyDuns === 'true');
    }
    const name = localStorage.getItem('verify-Name');
    if(name) {
      setName(name);
    }
    const orgName = localStorage.getItem('verify-orgName');
    if(orgName) {
      setOrgName(orgName);
    }
    const address = localStorage.getItem('verify-address');
    if(address) {
      setAddress(address);
    }
    const duns = localStorage.getItem('verify-duns');
    if(duns) {
      setDuns(duns);
    }
    const zip = localStorage.getItem('verify-zip');
    if(zip) {
      setZip(zip);
    }
    const city = localStorage.getItem('verify-city');
    if(city) {
      setCity(city);
    }
    const state = localStorage.getItem('verify-state');
    if(state) {
      setState(state);
    }
    const files = localStorage.getItem('verify-files');
    if(files) {
      setFiles(files);
    }
    const file = localStorage.getItem('verify-file');
    if(file) {
      setFile(file);
    }
    const runLimit = localStorage.getItem('verify-runLimit');
    if(runLimit) {
      setRunLimit(+runLimit);
    }
    const fileType = localStorage.getItem('verify-fileType');
    if(fileType) {
      setFiletype(fileType);
    }
  }, [])
  useEffect(() => {
    let count = accounts.split('\n');
    if(count) {
      count = count.filter(s => s.trim().length>0);
      setCount(count.length);
    }
  }, 
  [accounts]);

  const onOk = (value) => {
    if(value) {
      setTime(value.toDate());
    } else {
      setTime(new Date());
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Kích hoạt Tài Khoản"
        description={
          <>
              {profileModel?.errorMsg?.length> 0  &&
                <label style={{ color: "red", border: '1px solid red'}}>
                  <strong>{profileModel?.errorMsg}</strong></label>
              }
              <label>Chọn Giờ: </label>
              <br />
              <DatePicker showTime onOk={onOk} />
              <br />
              <br />
              <Checkbox checked={runRemote} onChange={e => {
                setRunRemote(e.target.checked)
              }}>
                <i style={{color:'red'}}>Chạy trên Server</i>
              </Checkbox>
              {runRemote && <SelectRemoteServer showAction={false} onSelected={(server) => {setServer(server)}} />}
              <br />

              <Row>
                <Col span={8}>
                  <Checkbox checked={verifyDUNS} onChange={e => {
                    setVerifyDUNS(e.target.checked)
                    window.localStorage.setItem("verify-duns-api", e.target.checked+'');
                  }}>
                    XM DUNS v 1.0
                  </Checkbox>
                  <br />
                  <Checkbox checked={fillDuns} onChange={e => setFillDuns(e.target.checked)}>
                    Điền Thông Tin DUNS
                  </Checkbox>
                  <br />
                  <Checkbox checked={selectOrg} onChange={e => setSelectOrg(e.target.checked)}>
                    DUNS -> Chọn Org
                  </Checkbox>
                  <br />
                  <Checkbox checked={whopay} onChange={e => setWhopay(e.target.checked)}>
                    Có Trả Lời "Who Pay..."
                  </Checkbox>
                  <br />
            
                </Col>
                <Col span={16}>
                  <b>Who pays for your ads?</b>
                  <br />
                  <Checkbox checked={!selectNoPayer} onChange={e => setSelectNoPayer(!e.target.checked)}>
                    "Yes, we pay Google Ads directly"
                  </Checkbox>
                  <br />
                  <Checkbox checked={selectNoPayer} onChange={e => setSelectNoPayer(e.target.checked)}>
                    "No, an agency pays and invoices us"
                  </Checkbox>
                </Col>
             </Row>
              
              {!verifyDUNS &&
                <>
                  <br />
                  <Checkbox checked={needActive} onChange={e => setNeedActive(e.target.checked)}>
                    Kích hoạt TK
                  </Checkbox>
                  <br />
                  <Checkbox checked={ignoreDie} onChange={e => setIgnoreDie(e.target.checked)}>
                    Kích hoạt cả TK Die
                  </Checkbox>
                  <br />
                  <Checkbox checked={verifyAd} onChange={e => setVerifyAd(e.target.checked)}>
                    Xác Minh NQC
                  </Checkbox>
                  <br />
                  <Checkbox checked={clearSchedules} onChange={e => setClearSchedules(e.target.checked)}>
                    Hủy Lịch Ads
                  </Checkbox>
                  <br />
                  <Checkbox checked={firstFileError} onChange={e => setFirstFileError(e.target.checked)}>
                    XM lần 1 Lỗi ~~ XM Lại
                  </Checkbox>
                  <br />
                  <Checkbox checked={cancelAfterVerify} onChange={e => setCancelAfterVerify(e.target.checked)}>
                    Hủy Sau Khi XM
                  </Checkbox>
                  <br />

                </>
              }

              <br />
             <Row>
              <Col span={12}>
                <strong><label>Nhập MCC ID (Nếu có nhiều TK MCC):</label></strong><br />
                <Input style={{width: 300}}
                    placeholder="MCC ID"
                    onChange={(e) => setMccId(e.target.value ) }
                />
              </Col>
              <Col span={12}>
                <SelectAccounts selectAccounts={profileModel?.selectAccounts}
                  onSelected={(selected) => setMccList(selected)}
                />
              </Col>
             </Row>
          
              <br />
              <label><strong>Tên ảnh Upload: Theo thứ tự upload Ảnh-1/Ảnh-2/Ảnh-Lỗi</strong>
                <br />VD: <i style={{color:'red'}}>1.jpg,2.pdf/4T.pdf-4S.pdf/7.pdf</i> = <u>Ảnh 1</u> [1.jpg hoặc 2.pdf] + <u>Ảnh 2</u> [4T.pdf Trước và 4S.pdf Sau] + <u>Ảnh Lỗi</u> [7.pdf]
              </label>
              <br />
              <Input style={{width: 500}}
                    value={files}
                    placeholder="Tên ảnh: 1,3,5/2"
                    onChange={(e) => {
                      setFiles(e.target.value );
                      window.localStorage.setItem("verify-files", e.target.value);
                    } }
                /><br />
              <br />
          
              <Row>
                <Col span={12}>
                <label><strong>Thông Tin NQC: </strong></label>
                <br />
                <form id="active-form">
                  <Row>
                    <Col span={12}>
                    <label>Name: </label><br />
                    <Input style={{width: 200}}
                        name="name"
                        autoComplete="name"
                        value={name}
                        placeholder="Name"
                        onChange={(e) => {
                          setName(e.target.value );
                          window.localStorage.setItem("verify-Name", e.target.value);
                        } }
                    /><br />
                    <label>Org Name: </label><br />
                    <Input style={{width: 200}}
                        name="organization"
                        autoComplete="organization"
                        value={orgName}
                        placeholder="Org Name"
                        onChange={(e) => {
                          setOrgName(e.target.value );
                          window.localStorage.setItem("verify-orgName", e.target.value);
                        } }
                    /><br />
                        <label>Address:</label><br />
                      <Input style={{width: 200}}
                        name="street"
                        autoComplete="street-address"
                          value={address}
                          placeholder="Address"
                          onChange={(e) => {
                            setAddress(e.target.value );
                            window.localStorage.setItem("verify-address", e.target.value);
                          } }
                      /><br />
                      <label>Zipcode: </label><br />
                      <Input style={{width: 200}}
                        name="postal"
                        autoComplete="postal-code"
                          value={zip}
                          placeholder="Zipcode"
                          onChange={(e) => {
                            setZip(e.target.value );
                            window.localStorage.setItem("verify-zip", e.target.value);
                          } }
                      />
                    </Col>
                    <Col span={12}>
                      <label>DUNS: </label><br />
                      <Input style={{width: 200}}
                        name="province"
                        autoComplete="address-level1"
                          value={duns}
                          placeholder="DUNS"
                          onChange={(e) => {
                            setDuns(e.target.value );
                            window.localStorage.setItem("verify-duns", e.target.value);
                          } }
                      />
               
                        <br />
                      <label>City: </label><br />
                      <Input style={{width: 200}}
                      name="city"
                      autoComplete="address-level2"
                          value={city}
                          placeholder="City"
                          onChange={(e) => {
                            setCity(e.target.value );
                            window.localStorage.setItem("verify-city", e.target.value);
                          } }
                      />
                        <br />
                      <label>State: </label><br />
                      <Input style={{width: 200}}
                      name="State"
                      
                          value={state}
                          placeholder="state"
                          onChange={(e) => {
                            setState(e.target.value );
                            window.localStorage.setItem("verify-state", e.target.value);
                          } }
                      />
                        <br />
                      <label>File XM: </label><br />
                      <Input style={{width: 200}}
                        name="file"
                            value={file}
                            placeholder="File XM"
                            onChange={(e) => {
                              setFile(e.target.value );
                              window.localStorage.setItem("verify-file", e.target.value);
                            } }
                        />
                        <label>Chọn Loại File: </label>
                        <Select
                            style={{width: '200px'}}
                            value={fileType}
                            placeholder="Chọn Loại File ... "
                            onChange={(v) => {
                              setFiletype(v);
                              window.localStorage.setItem("verify-fileType", v);
                            }}
                            options={[
                              {
                                label: 'Passport',
                                value: 'Passport',
                              },
                              {
                                label: 'CCCD',
                                value: 'National Identity Card',
                              },
                            ]}
                          />
                    </Col>
                  </Row>
                  <button type="submit" style={{display:'none'}}></button>
                </form>
                </Col>
                <Col span={12}>
                  <label><strong>Nhập ID Tài khoản <i style={{color:'red'}}>(Mỗi ID 1 dòng)</i>: {count}</strong></label>
                  <TextArea rows={5} 
                        value={accounts} 
                        onChange={(e) => setAccounts(e.target.value)} 
                  />

                  <br />
                  <Checkbox checked={runAll} onChange={e => setRunAll(e.target.checked)}>
                      <b>Chạy Toàn Bộ TK con</b>
                  </Checkbox>
                  <br />
                  {!runAll &&
                    <>
                      <label>Chạy Giới Hạn SL: </label>
                      <Input style={{width: 100}}
                          value={runLimit}
                          type="number"
                          placeholder="Giói Hạn: SL"
                          onChange={(e) => {
                            setRunLimit(+e.target.value);
                            window.localStorage.setItem("verify-runLimit", e.target.value);
                          } }
                      />
                    </>
                  }
                  
                </Col>
              </Row>
          </>
        }
        onConfirm={() => active()}
      >
        <Button danger style={{backgroundColor:'green', color:'white'}}>Kích Hoạt - Xác Minh</Button>
      </Popconfirm>
    </>
  );
}
export default ActiveAccounts;